import { Card, Player } from './types';

// Card value conversion
export const CARD_VALUE_MAP: Record<string, string> = {
   'T': '10',
   'J': 'J',
   'Q': 'Q',
   'K': 'K',
   'A': 'A'
};

export function getCardImageSrc(card: Card): string {
   const value = CARD_VALUE_MAP[card.rank] || card.rank;
   return `./images/cards/${value}_${card.suit}.png`;
}

// Initial deck position in the center of the table
export const DECK_POSITION = {
   x: 515, // Center X
   y: 260  // Center Y
};
